import { z } from 'zod';
import { video23AudioDataSchema } from '../next/builder/handlers.video23/typings.video23.js';

const v1Schema = z.object({
  version: z.literal("v1"),
  showmode: z.enum(["text", "overlay"]),
  color: z.string(),
  backgroundImage: z.string().nullish().default(null),
  hotspots: z.array(z.object({
    id: z.union([z.number(), z.string()]).transform(id => String(id)),
    title: z.string().nullish().default(null),
    text: z.string(),
    position: z.object({
      x: z.number(),
      y: z.number()
    }),
    mediaType: z.union([z.null(), z.enum(["photo-id", "photo", "sound", "video"])]).nullish().default(null),
    mediaPath: z.string().nullish().default(null),
    mediaCopyright: z.string().nullish().default(null)
  })).default([])
});
const imageHotspotSchema = z.object({
  id: z.union([z.number(), z.string()]).transform(id => String(id)),
  title: z.string().nullish().default(null),
  text: z.string(),
  hotspotGraphicsURL: z.string().nullish().default(null),
  hotspotGraphicsAlt: z.string().nullish().default(null),
  position: z.object({
    x: z.number(),
    y: z.number()
  }),
  media: z.object({
    selectedMedia: z.union([z.null(), z.enum(["photo", "sound", "video"])]).default(null),
    photo: z.object({
      src: z.string(),
      copyright: z.string().nullish().default(null),
      alt: z.string().nullish().default(null),
      longDesc: z.string().nullish().default(null)
    }).optional(),
    sound: z.object({
      id: z.string().nullish().default(null),
      video23: video23AudioDataSchema.nullish().default(null)
    }).optional(),
    video: z.object({
      id: z.string()
    }).optional()
  })
});
const v2Schema = z.object({
  version: z.literal("v2"),
  settings: z.object({
    showMode: z.enum(["modal", "overlay"]).default("overlay"),
    showIndexOnHotspots: z.boolean().optional(),
    hotspotColor: z.string().optional()
  }).default({
    showMode: "overlay"
  }),
  background: z.object({
    src: z.string(),
    dimensions: z.object({
      naturalWidth: z.number(),
      naturalHeight: z.number()
    }),
    aspectRatio: z.number(),
    alt: z.string().nullish().default(null),
    longDesc: z.string().nullish().default(null)
  }).nullish().default(null),
  hotspots: z.array(imageHotspotSchema).default([])
});
const imageHotspotsDataSchema = z.preprocess(data => typeof data === "object" && data != null && !("version" in data) ? {
  ...data,
  version: "v1"
} : data, z.discriminatedUnion("version", [v2Schema, v1Schema]));

export { imageHotspotsDataSchema };
//# sourceMappingURL=image-hotspots.component-data.js.map
